module.exports = __webpack_public_path__ + "img/yeosu_thumbnail.a8ba64e1.jpg";